import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { isFightSport } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedEventsListMarkets';

export const MatchesFilterLabel = ({ sportId }: { sportId: string }) => {
    if (isFightSport(sportId)) {
        return (
            <I18n
                langKey='events.table.filter.upcoming-fights'
                defaultText='Upcoming Fights'
            />
        );
    }

    return (
        <I18n
            langKey='events.table.filter.matches'
            defaultText='Matches'
        />
    );
};
